const body = document.body;
const threshold = 50;
const thresholdTop = 50;

let lastScrollTop = 0;

function checkScroll() {
  const scrollTop = document.documentElement.scrollTop;

  if (Math.abs(scrollTop - lastScrollTop) >= threshold) {
    body.setAttribute('data-scrolling-direction', scrollTop > lastScrollTop ? 'down' : 'up');
    lastScrollTop = scrollTop;
  }

  body.setAttribute('data-scrolling-started', scrollTop > thresholdTop ? 'true' : 'false');
}

export default function setScrolling() {
  body.setAttribute('data-scrolling-direction', 'down');
  body.setAttribute('data-scrolling-started', 'false');

  document.addEventListener('scroll', checkScroll);
  checkScroll();
}
